import { get } from 'lodash-es';

export const selectConfirmCustomersModalId = (state) => get(state, 'confirmCustomersModalId');
export const selectCombineCustomersModalId = (state) => get(state, 'combineCustomersModalId');
